export class IntegrationImport {
	id: number;

	insertCount: number;
	updateCount: number;
	hasError: boolean;
	exception: string;
	startDate: Date;
	endDate: Date;
	duration: number;
}
